{
  "name": "@replit/extensions",
  "version": "1.10.0",
  "description": "The Replit Extensions client is a module that allows you to easily interact with the Workspace.",
  "types": "./src/index.ts",
  "exports": {
    "./package.json": "./package.json",
    ".": {
      "types": "./src/index.ts",
      "import": {
        "default": "./src/index.ts"
      }
    }
  },
  "publishConfig": {
    "exports": {
      "./package.json": "./package.json",
      ".": {
        "types": "./dist/index.d.ts",
        "import": {
          "default": "./dist/index.js"
        },
        "default": "./dist/index.cjs",
        "require": "./dist/index.js"
      }
    },
    "types": "./dist/index.d.ts"
  },
  "type": "module",
  "unpkg": "dist/index.global.js",
  "scripts": {
    "build": "tsup src/index.ts  --sourcemap --dts --platform browser --format esm,cjs,iife --global-name replit",
    "test:build": "jest buildTests",
    "lint": "npx prettier --write src/*",
    "lint:check": "npx prettier -l src/*",
    "type:check": "tsc --noEmit",
    "clean": "rm -rf dist",
    "generate:docs": "npx typedoc src/index.ts --json docs/main.json --plugin ./util/signature-plugin/index.cjs"
  },
  "files": [
    "dist/*"
  ],
  "keywords": [
    "replit",
    "extensions",
    "api-client"
  ],
  "author": "",
  "license": "MIT",
  "dependencies": {
    "@codemirror/state": "^6.2.0",
    "@noble/curves": "^1.0.0",
    "@root/asn1": "^1.0.0",
    "b64u-lite": "^1.1.0",
    "comlink": "^4.3.1"
  },
  "devDependencies": {
    "@types/root__asn1": "^1.0.2",
    "esbuild": "^0.15.18",
    "prettier": "^2.7.1",
    "tsup": "^6.6.3",
    "typedoc": "^0.24.8",
    "typescript": "^4.9.3"
  }
}
